import { render, staticRenderFns } from "./TwDashBoardTradingStatus.vue?vue&type=template&id=333337b5&scoped=true&"
import script from "./TwDashBoardTradingStatus.vue?vue&type=script&lang=js&"
export * from "./TwDashBoardTradingStatus.vue?vue&type=script&lang=js&"
import style0 from "./TwDashBoardTradingStatus.vue?vue&type=style&index=0&id=333337b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333337b5",
  null
  
)

export default component.exports